<template>
  <div>
    <vs-row class="mb-4">
      <vs-col
        ><h5><i class="dot"></i>{{ $t("근골격계부담작업") }}</h5></vs-col
      >
    </vs-row>
    <div>
      <!-- PC 버전 -->
      <div v-if="!isMobile || isPrint">
        <div class="overflow-x-auto" style="border: 1px solid #cdcdcd; border-bottom: none">
          <!-- 구분 -->
          <vs-row class="grid-title-11">
            <vs-col class="grid-title head">
              <div>
                <span>{{ $t("구분") }}</span>
                <div v-if="!isPrint" class="mt-2" style="display: flex; font-family: 'Noto Sans KR'; font-style: normal; font-weight: 500; font-size: 12px; line-height: 120%; color: #696d71">
                  <span><feather-icon icon="AlertCircleIcon" svgClasses="h-5 w-5" class="mr-1" /></span>
                  <span>{{ $t("작업 그림 클릭 시 작업 해설을 확인할 수 있습니다.") }}</span>
                </div>
              </div>
            </vs-col>
            <vs-col class="grid-11">
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 1 })"
                  :html="$t('하루에 4시간 이상 집중적으로 자료입력 등을 위해 키보드 또는 마우스를 조작하는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(1)">
                    <span>{{ $t("제 ①호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/1.png" :alt="$t('제 n호', { n: 1 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 2 })"
                  :html="$t('하루에 총 2시간 이상 목,어깨,팔꿈치, 손목 또는 손을 사용하여 같은 동작을 반복하는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(2)">
                    <span>{{ $t("제 ②호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/2.png" :alt="$t('제 n호', { n: 2 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 3 })"
                  :html="
                    $t('하루에 총 2시간 이상 머리 위에 손이 있거나, 팔꿈치가 어깨 위에 있거나, 팔꿈치를 몸통으로부터 들거나,팔꿈치를 몸통뒤쪽에 위치하도록 하는 상태에서 이루어지는 작업<br>') +
                    $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')
                  "
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(3)">
                    <span>{{ $t("제 ③호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/3.png" :alt="$t('제 n호', { n: 3 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 4 })"
                  :html="$t('지지되지 않은 상태이거나 임의로 자세를 바꿀 수 없는 조건에서, 하루에 총 2시간이상 목이나 허리를 구부리거나 트는 상태에서 이루어지는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(4)">
                    <span>{{ $t("제 ④호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/4.png" :alt="$t('제 n호', { n: 4 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 5 })"
                  :html="$t('하루에 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세에서 이루어지는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(5)">
                    <span>{{ $t("제 ⑤호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/5.png" :alt="$t('제 n호', { n: 5 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 6 })"
                  :html="
                    $t('하루에 총 2시간 이상 지지되지 않은 상태에서 1kg이상의 물건을 한손의 손가락으로 집어 옮기거나,2kg이상에 상응하는 힘을 가하여 한손의 손가락으로 물건을 쥐는 작업<br>') +
                    $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')
                  "
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(6)">
                    <span>{{ $t("제 ⑥호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/6.png" :alt="$t('제 n호', { n: 6 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 7 })"
                  :html="$t('하루에 총 2시간 이상 지지되지 않은 상태에서 4.5kg이상의 물건을 한 손으로 들거나 동일한 힘으로 쥐는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(7)">
                    <span>{{ $t("제 ⑦호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/7.png" :alt="$t('제 n호', { n: 7 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 8 })"
                  :html="$t('하루에 10회 이상 25kg이상의 물체를 드는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(8)">
                    <span>{{ $t("제 ⑧호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/8.png" :alt="$t('제 n호', { n: 8 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 9 })"
                  :html="$t('하루에 25회 이상 10kg이상의 물체를 무릎 아래에서 들거나,어깨 위에서 들거나,팔을 뻗은 상태에서 드는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(9)">
                    <span>{{ $t("제 ⑨호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/9.png" :alt="$t('제 n호', { n: 9 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 10 })"
                  :html="$t('하루에 총 2시간 이상,분당 2회 이상 4.5kg 이상의 물체를 드는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(10)">
                    <span>{{ $t("제 ⑩호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/10.png" :alt="$t('제 n호', { n: 10 })" />
                  </div>
                </vx-tooltip>
              </div>
              <div class="item">
                <vx-tooltip
                  :title="$t('근골격계부담작업 제n호', { n: 11 })"
                  :html="$t('하루에 총 2시간 이상 시간당 10회 이상 손 또는 무릎을 사용하여 반복적으로 충격을 가하는 작업<br>') + $t('<br>※ 자세한 내용을 보시려면 작업그림을 클릭하세요.<br>')"
                  style="margin-left: 4px; display: flex; align-items: center; justify-content: center"
                  position="top"
                  delay=".1s"
                >
                  <div class="grid justify-center cursor-pointer" style="align-items: center" @click="showPopup(11)">
                    <span>{{ $t("제 ⑪호") }}</span>
                    <img src="@/assets/images/MusculoskeletalTensionExercisesTable/11.png" :alt="$t('제 n호', { n: 11 })" />
                  </div>
                </vx-tooltip>
              </div>
            </vs-col>
          </vs-row>

          <!-- 노출시간 -->
          <vs-row class="grid-title-11">
            <vs-col class="grid-title head">{{ $t("노출시간") }}</vs-col>
            <vs-col class="grid-11">
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 4 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에 총") }}<br />{{ $t("n시간 이상", { n: 2 }) }}</div>
              </div>
            </vs-col>
          </vs-row>

          <!-- 노출빈도 -->
          <vs-row class="grid-title-11">
            <vs-col class="grid-title head">{{ $t("노출빈도") }}</vs-col>
            <vs-col class="grid-11">
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에") }}<br />{{ $t("총 n회 이상", { n: 10 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("하루에") }}<br />{{ $t("총 n회 이상", { n: 25 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("분당") }}<br />{{ $t("n회 이상", { n: 2 }) }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("시간당") }}<br />{{ $t("n회 이상", { n: 10 }) }}</div>
              </div>
            </vs-col>
          </vs-row>

          <!-- 신체부위 -->
          <vs-row class="grid-title-11">
            <vs-col class="grid-title head">{{ $t("신체부위") }}</vs-col>
            <vs-col class="grid-11">
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("손, 손가락,") }}<br />{{ $t("팔, 어깨") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("목, 어깨,손") }}<br />{{ $t("목, 손,팔꿈치") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("어깨, 팔") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("목, 허리") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("다리, 무릎") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("손가락") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("손") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("허리") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("손, 무릎") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("허리") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("손, 무릎,") }}<br />{{ $t("팔꿈치") }}</div>
              </div>
            </vs-col>
          </vs-row>

          <!-- 작업자세 및 내용 -->
          <vs-row class="grid-title-11">
            <vs-col class="grid-title head">{{ $t("작업자세 및 내용") }}</vs-col>
            <vs-col class="grid-11">
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("집중적인 자료 입력 작업 (마우스, 키보드 사용)") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("같은 동작 반복작업") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("머리 위에 손, 팔꿈치가 몸통으로부터 들림, 팔꿈치를 몸통 뒤쪽에 위치") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("구부리거나 비틈 (지지되지 않은 상태,자세변경불가)") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("쪼그리고 앉거나 무릎을 굽힘") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("한 손가락 집어 옮기거나 쥐는 작업 (지지되지 않은 상태)") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("물건을 한손으로 들거나 잡는 작업") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("물건을 드는 작업") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("어깨 위에서 들기, 팔을 뻗은 상태에서 물건을 드는 작업") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("물건을 드는 작업") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("반복적인 충격") }}</div>
              </div>
            </vs-col>
          </vs-row>

          <!-- 무게 -->
          <vs-row class="grid-title-11">
            <vs-col class="grid-title head">{{ $t("무게") }}</vs-col>
            <vs-col class="grid-11">
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("1kg이상의 물건 들기, 2kg이상에 상응하는 힘으로 쥐기") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("4.5kg이상의 물건 들기, 동일한 힘으로집기") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("25kg이상") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("10kg이상") }}</div>
              </div>
              <div class="item">
                <div class="flex" style="align-items: center">{{ $t("4.5kg이상") }}</div>
              </div>
              <div class="item head">
                <div class="flex" style="align-items: center">-</div>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </div>

      <!-- 모바일 버전 -->
      <div v-else>
        <div v-if="!isPrint" class="mb-4" style="display: flex; font-family: 'Noto Sans KR'; font-style: normal; font-weight: 500; font-size: 12px; line-height: 120%; color: #696d71">
          <span><feather-icon icon="AlertCircleIcon" svgClasses="h-5 w-5" class="mr-1" /></span>
          <span>{{ $t("작업 번호 클릭 시 작업 해설을 확인할 수 있습니다.") }}</span>
        </div>

        <!-- 모바일 카드 리스트 -->
        <div class="mobile-cards">
          <!-- 카드 1 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(1)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ①호") }}</span>
                <span>{{ $t("자료입력 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/1.png" :alt="$t('제 n호', { n: 1 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 4시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("손, 손가락, 팔, 어깨") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("집중적인 자료 입력 작업 (마우스, 키보드 사용)") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>-</span>
              </div>
            </div>
          </div>

          <!-- 카드 2 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(2)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ②호") }}</span>
                <span>{{ $t("반복 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/2.png" :alt="$t('제 n호', { n: 2 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("목, 어깨, 손목, 손, 팔꿈치") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("같은 동작 반복작업") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>-</span>
              </div>
            </div>
          </div>

          <!-- 카드 3 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(3)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ③호") }}</span>
                <span>{{ $t("팔 위치 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/3.png" :alt="$t('제 n호', { n: 3 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("어깨, 팔") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("머리 위에 손, 팔꿈치가 몸통으로부터 들림, 팔꿈치를 몸통 뒤쪽에 위치") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>-</span>
              </div>
            </div>
          </div>

          <!-- 카드 4 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(4)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ④호") }}</span>
                <span>{{ $t("목/허리 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/4.png" :alt="$t('제 n호', { n: 4 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("목, 허리") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("구부리거나 비틈 (지지되지 않은 상태, 자세변경불가)") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>-</span>
              </div>
            </div>
          </div>

          <!-- 카드 5 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(5)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ⑤호") }}</span>
                <span>{{ $t("무릎 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/5.png" :alt="$t('제 n호', { n: 5 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("다리, 무릎") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("쪼그리고 앉거나 무릎을 굽힘") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>-</span>
              </div>
            </div>
          </div>

          <!-- 카드 6 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(6)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ⑥호") }}</span>
                <span>{{ $t("손가락 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/6.png" :alt="$t('제 n호', { n: 6 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("손가락") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("한 손가락 집어 옮기거나 쥐는 작업 (지지되지 않은 상태)") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>{{ $t("1kg이상의 물건 들기, 2kg이상에 상응하는 힘으로 쥐기") }}</span>
              </div>
            </div>
          </div>

          <!-- 카드 7 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(7)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ⑦호") }}</span>
                <span>{{ $t("한 손 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/7.png" :alt="$t('제 n호', { n: 7 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>손</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("물건을 한손으로 들거나 잡는 작업") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>{{ $t("4.5kg이상의 물건 들기, 동일한 힘으로집기") }}</span>
              </div>
            </div>
          </div>

          <!-- 카드 8 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(8)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ⑧호") }}</span>
                <span>{{ $t("무거운 물체") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/8.png" :alt="$t('제 n호', { n: 8 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>{{ $t("하루에 총 10회 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("허리") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("물건을 드는 작업") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>{{ $t("25kg이상") }}</span>
              </div>
            </div>
          </div>

          <!-- 카드 9 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(9)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ⑨호") }}</span>
                <span>{{ $t("자세별 물체") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/9.png" :alt="$t('제 n호', { n: 9 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>-</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>{{ $t("하루에 총 25회 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("손, 무릎") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("어깨 위에서 들기, 팔을 뻗은 상태에서 물건을 드는 작업") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>{{ $t("10kg이상") }}</span>
              </div>
            </div>
          </div>

          <!-- 카드 10 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(10)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ⑩호") }}</span>
                <span>{{ $t("빈번한 드는 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/10.png" :alt="$t('제 n호', { n: 10 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>{{ $t("분당 2회 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("허리") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("물건을 드는 작업") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>{{ $t("4.5kg이상") }}</span>
              </div>
            </div>
          </div>

          <!-- 카드 11 -->
          <div class="mobile-card">
            <div class="mobile-card-header" @click="showPopup(11)">
              <div class="mobile-card-title">
                <span class="mobile-card-number">{{ $t("제 ⑪호") }}</span>
                <span>{{ $t("충격 작업") }}</span>
              </div>
              <img src="@/assets/images/MusculoskeletalTensionExercisesTable/11.png" :alt="$t('제 n호', { n: 11 })" class="mobile-card-img" />
            </div>
            <div class="mobile-card-body">
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출시간") }}</span>
                <span>{{ $t("하루에 총 2시간 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("노출빈도") }}</span>
                <span>{{ $t("시간당 10회 이상") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("신체부위") }}</span>
                <span>{{ $t("손, 무릎, 팔꿈치") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("작업자세 및 내용") }}</span>
                <span>{{ $t("반복적인 충격") }}</span>
              </div>
              <div class="mobile-card-item">
                <span class="mobile-card-label">{{ $t("무게") }}</span>
                <span>-</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isMobile && !isPrint" class="py-4 hidden xl:flex">
        <vs-col class="w-auto ml-auto flex" style="color: #7e72f2">
          <span class="mr-4 cursor-pointer" style="display: flex; align-items: center" @click="addItem">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.8335 4.16536C10.8335 3.70513 10.4604 3.33203 10.0002 3.33203C9.53993 3.33203 9.16683 3.70513 9.16683 4.16536V9.16537H4.16683C3.70659 9.16537 3.3335 9.53846 3.3335 9.9987C3.3335 10.4589 3.70659 10.832 4.16683 10.832H9.16683V15.832C9.16683 16.2923 9.53993 16.6654 10.0002 16.6654C10.4604 16.6654 10.8335 16.2923 10.8335 15.832V10.832H15.8335C16.2937 10.832 16.6668 10.4589 16.6668 9.9987C16.6668 9.53846 16.2937 9.16537 15.8335 9.16537H10.8335V4.16536Z"
                fill="#7E72F2"
              />
            </svg>
            {{ $t("항목추가") }}
          </span>
          <span v-if="value.length > 0" class="mr-4 cursor-pointer" style="display: flex; align-items: center" @click="removeItem">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.3335 10.0013C3.3335 9.54106 3.70659 9.16797 4.16683 9.16797H15.8335C16.2937 9.16797 16.6668 9.54106 16.6668 10.0013C16.6668 10.4615 16.2937 10.8346 15.8335 10.8346H4.16683C3.70659 10.8346 3.3335 10.4615 3.3335 10.0013Z"
                fill="#7E72F2"
              />
            </svg>
            {{ $t("항목삭제") }}
          </span>
        </vs-col>
      </div>

      <!-- PC 버전 테이블 -->
      <div v-if="value.length > 0 && (!isMobile || isPrint)">
        <vs-row class="grid-title-11">
          <vs-col class="grid-title head">{{ $t("단위작업명") }}</vs-col>
          <vs-col class="head">{{ $t("해당여부") }}</vs-col>
        </vs-row>
        <vs-row v-for="(data, index) in value" :key="index" class="grid-title-11">
          <vs-col class="grid-title">
            <span v-if="isPrint" class="print-input">{{ data[0] }}</span>
            <ml-input v-else class="w-full" v-model="data[0]" />
          </vs-col>
          <vs-col class="grid-11">
            <div class="item">
              <div class="flex" style="align-items: center">
                ①
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[1]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[1]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ②
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[2]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[2]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ③
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[3]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[3]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ④
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[4]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[4]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ⑤
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[5]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[5]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ⑥
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[6]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[6]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ⑦
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[7]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[7]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ⑧
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[8]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[8]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ⑨
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[9]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[9]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ⑩
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[10]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[10]" />
              </div>
            </div>
            <div class="item">
              <div class="flex" style="align-items: center">
                ⑪
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[11]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[11]" />
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <!-- 모바일 버전 테이블 -->
      <div v-if="value.length > 0 && isMobile" class="mt-6">
        <h6 class="mb-4 font-semibold">{{ $t("단위작업명 및 해당여부") }}</h6>
        <div v-for="(data, index) in value" :key="index" class="mobile-task-item">
          <div class="mobile-task-header">
            <span v-if="isPrint" class="mobile-task-title print-input">{{ data[0] }}</span>
            <ml-input v-else class="w-full" v-model="data[0]" placeholder="단위작업명" />
            <span v-if="!isPrint" class="mobile-task-delete-btn" @click="removeSpecificItem(index)">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.3335 10.0013C3.3335 9.54106 3.70659 9.16797 4.16683 9.16797H15.8335C16.2937 9.16797 16.6668 9.54106 16.6668 10.0013C16.6668 10.4615 16.2937 10.8346 15.8335 10.8346H4.16683C3.70659 10.8346 3.3335 10.4615 3.3335 10.0013Z"
                  fill="#FF5252"
                />
              </svg>
            </span>
          </div>
          <div class="mobile-task-body">
            <div class="mobile-checkbox-row">
              <div class="mobile-checkbox-item">
                <span>{{ $t("① 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[1]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[1]" />
              </div>
              <div class="mobile-checkbox-item">
                <span>{{ $t("② 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[2]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[2]" />
              </div>
              <div class="mobile-checkbox-item">
                <span>{{ $t("③ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[3]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[3]" />
              </div>
            </div>
            <div class="mobile-checkbox-row">
              <div class="mobile-checkbox-item">
                <span>{{ $t("④ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[4]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[4]" />
              </div>
              <div class="mobile-checkbox-item">
                <span>{{ $t("⑤ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[5]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[5]" />
              </div>
              <div class="mobile-checkbox-item">
                <span>{{ $t("⑥ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[6]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[6]" />
              </div>
            </div>
            <div class="mobile-checkbox-row">
              <div class="mobile-checkbox-item">
                <span>{{ $t("⑦ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[7]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[7]" />
              </div>
              <div class="mobile-checkbox-item">
                <span>{{ $t("⑧ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[8]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[8]" />
              </div>
              <div class="mobile-checkbox-item">
                <span>{{ $t("⑨ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[9]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[9]" />
              </div>
            </div>
            <div class="mobile-checkbox-row">
              <div class="mobile-checkbox-item">
                <span>{{ $t("⑩ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[10]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[10]" />
              </div>
              <div class="mobile-checkbox-item">
                <span>{{ $t("⑪ 호") }}</span>
                <span v-if="isPrint" class="print-checkbox ml-2"
                  ><i><feather-icon v-if="data[11]" svgClasses="w-4 w-5" icon="CheckIcon" /></i
                ></span>
                <vs-checkbox v-else v-model="data[11]" />
              </div>
              <div class="mobile-checkbox-item"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 항목추가 버튼 -->
      <div v-if="isMobile" class="mt-4">
        <button class="mobile-add-btn" @click="addItem">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8335 4.16536C10.8335 3.70513 10.4604 3.33203 10.0002 3.33203C9.53993 3.33203 9.16683 3.70513 9.16683 4.16536V9.16537H4.16683C3.70659 9.16537 3.3335 9.53846 3.3335 9.9987C3.3335 10.4589 3.70659 10.832 4.16683 10.832H9.16683V15.832C9.16683 16.2923 9.53993 16.6654 10.0002 16.6654C10.4604 16.6654 10.8335 16.2923 10.8335 15.832V10.832H15.8335C16.2937 10.832 16.6668 10.4589 16.6668 9.9987C16.6668 9.53846 16.2937 9.16537 15.8335 9.16537H10.8335V4.16536Z"
              fill="#FFFFFF"
            />
          </svg>
          {{ $t("항목추가") }}
        </button>
      </div>
    </div>

    <popup-alert v-model="alert.show" :title="alert.title" :html="alert.html" :buttons="alert.buttons"></popup-alert>
  </div>
</template>

<script>
import PopupAlert from "@/popup/PopupAlert";
export default {
  name: "MusculoskeletalTensionExercisesTable",
  components: { PopupAlert },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isPrint: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      isMobile: false,
      alert: {
        show: false,
        title: "통증 기준표",
        html:
          '<div style="width: 540px; padding: 24px;">' +
          `<p style="font-size: 16px;"><b>{{ $t('약한 통증 :') }}</b>{{ $t('약간 불편한 정도이나 작업에 열중할 때는 못 느낀다') }}</p>` +
          `<p style="font-size: 16px;"><b>{{ $t('중간 통증 :') }}</b>{{ $t('작업 중 통증이 있으나 귀가 후 휴식을 취하면 괜찮다') }}</p>` +
          `<p style="font-size: 16px;"><b>{{ $t('심한 통증 :') }}</b>{{ $t('작업 중 통증이 비교적 심하고 귀가 후에도 통증이 계속된다') }}</p>` +
          `<p style="font-size: 16px;"><b>{{ $t('매우 심한 통증 :') }}</b>{{ $t('통증 때문에 작업은 물론 일상생활을 하기가 어렵다') }}</p>` +
          "</div>",
        buttons: [],
      },
      table: this.value,
    };
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    addItem() {
      this.table.push(["", false, false, false, false, false, false, false, false, false, false, false]);
    },
    removeItem() {
      this.table.pop();
    },
    removeSpecificItem(index) {
      this.table.splice(index, 1);
    },
    showPopup(num) {
      const html = this.$t(`popup293_${num}`);      
      this.alert.title = this.$t("근골격계부담작업 제n호", { n: num });
      this.alert.html = `<div style="width: 100%; max-width: 800px;">${html}</div>`;
      this.alert.show = true;
    },
  },
  async created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
};
</script>

<style lang="scss" scoped>
.grid-title-11 {
  display: grid !important;
  grid-template-columns: 160px 1fr;

  .head {
    text-align: center;
    background-color: #f9f9f9;
    padding: 7px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  .grid-title {
    padding: 7px;
  }

  & > .grid-11 {
    display: grid;
    grid-template-columns: repeat(11, minmax(115px, 1fr));

    & > .item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 7px;
      border-right: 1px solid #cdcdcd;
      border-bottom: 1px solid #cdcdcd;
      text-align: center;

      &:last-child {
        border-right: none;
      }
    }
  }
}
.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  & > i {
    width: 20px;
    height: 20px;
    border: 2px solid #cdcdcd;
    position: relative;
    margin-right: 6px;
  }
  & .feather-icon {
    transform: translateY(-4px);
  }
}
.print-radio {
  & > i {
    border-radius: 20px;
  }
}

// 모바일 카드 스타일
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-card {
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9f9f9;
  padding: 12px 16px;
  border-bottom: 1px solid #cdcdcd;
  cursor: pointer;
}

.mobile-card-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-card-number {
  font-weight: 700;
  font-size: 16px;
  color: #200c63;
}

.mobile-card-img {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

.mobile-card-body {
  padding: 16px;
}

.mobile-card-item {
  display: flex;
  margin-bottom: 12px;
  gap: 12px;
}

.mobile-card-item:last-child {
  margin-bottom: 0;
}

.mobile-card-label {
  font-weight: 600;
  font-size: 14px;
  color: #200c63;
  min-width: 100px;
}

// 모바일 테이블 스타일
.mobile-task-item {
  margin-bottom: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  overflow: hidden;
}

.mobile-task-header {
  background-color: #f9f9f9;
  padding: 12px;
  border-bottom: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
}

.mobile-task-title {
  font-weight: 600;
}

.mobile-task-body {
  padding: 12px;
}

.mobile-checkbox-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.mobile-checkbox-row:last-child {
  margin-bottom: 0;
}

.mobile-checkbox-item {
  display: flex;
  align-items: center;
  flex: 1 0 30%;
  min-width: 100px;
  margin-bottom: 8px;
  gap: 8px;
}

.mobile-task-delete-btn {
  cursor: pointer;
  color: #ff5252;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.mobile-add-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #7e72f2;
  color: #fff;
  padding: 10px 16px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  justify-content: center;
}

.mobile-add-btn:hover {
  background-color: #6a5fe0;
}
</style>
